export const brand = {
  name: "Qotta",
  domain: "Qotta.co",
  url: "https://qotta.co/",
  socialImageUrl: "https://qotta.co/images/qotta-product-video-poster.jpg",
  socialImageAlt: "A website visitor exploring a kitchen business website on a desktop computer",
  embedScriptUrl: "https://qotta.co/embed.js",
} as const;

export function pageTitle(page?: string) {
  return page
    ? `${page} | ${brand.name}`
    : `${brand.name} | Embedded Discovery & Quote Platform`;
}
